import * as React from 'react';
import { Route, Switch } from 'react-router';
import { AvailabilityReportsOutbox } from './AvailabilityReportsOutbox/AvailabilityReportsOutbox';
import { AvailabilityReportsArchive } from './AvailabilityReportsArchive/AvailabilityReportsArchive';
import { StudentPageHeader } from '../components/StudentPageHeader';
import '../components/StudentHub.scss';
import './AvailabilityReports.scss';

export const AvailabilityReportsRouting = allProps => {
  const isPrevious = allProps.location.pathname.indexOf('/archive') !== -1;
  const isHistory = isPrevious || allProps.location.pathname.indexOf('/history') !== -1;
  return (
    <main className="parentPage studentHubPage studentAvailabilityPage">
      <StudentPageHeader
        title="Availability"
        tabs={[
          { label: 'Upcoming', active: !isHistory, onClick: () => allProps.history.push('/availabilityReports/outbox') },
          { label: 'Past this year', active: isHistory && !isPrevious, onClick: () => allProps.history.push('/availabilityReports/history') },
          { label: 'Previous years', active: isPrevious, onClick: () => allProps.history.push('/availabilityReports/archive') }
        ]}
      />
      <Switch>
        <Route
          exact
          path={'/availabilityReports/outbox'}
          render={props => <AvailabilityReportsOutbox {...props} user={allProps.user} />}
        />
        <Route
          exact
          path={'/availabilityReports/history'}
          render={props => <AvailabilityReportsArchive {...props} user={allProps.user} mode="current" />}
        />
        <Route
          exact
          path={'/availabilityReports/archive'}
          render={props => <AvailabilityReportsArchive {...props} user={allProps.user} mode="previous" />}
        />
      </Switch>
    </main>
  );
};

AvailabilityReportsRouting.displayName = 'AvailabilityReportsRouting';
